import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes, faFilter, faDownload } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';

// ─── Modal Generico para Selección EPS ──────────────────────
const ModalSelect = ({ open, onClose, title, onSelect, idMenu }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            setSearchTerm('');
            fetchData(1, '');
        }
    }, [open]);

    const fetchData = async (page = 1, search = '') => {
        setLoading(true);
        const u = localStorage.getItem('idusuario') || 1;
        const formData = new FormData();

        if (search) {
            formData.append('BUS_nombre', search);
            formData.append('BUS_razon_social', search);
            formData.append('BUS_id', search);
        }

        try {
            const res = await authAxios.post(`master/index/${idMenu}/${u}?page=${page}`, formData);
            if (res.data?.data?.data) {
                setItems(res.data.data.data);
            } else if (res.data?.data) {
                setItems(res.data.data);
            }
        } catch (e) {
            console.error("Error cargando modal:", e);
        }
        setLoading(false);
    };

    const handleSearch = () => {
        fetchData(1, searchTerm);
    };

    if (!open) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header bg-primary text-white py-2">
                        <h5 className="modal-title m-0" style={{ fontSize: '1.1rem' }}>{title}</h5>
                        <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
                    </div>
                    <div className="modal-body p-3">
                        <div className="input-group mb-3">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Buscar..."
                                value={searchTerm}
                                onChange={e => {
                                    setSearchTerm(e.target.value);
                                    if (e.target.value.length > 2 || e.target.value === '') {
                                        fetchData(1, e.target.value);
                                    }
                                }}
                            />
                            <button className="btn btn-primary btn-sm" onClick={handleSearch}>
                                <FontAwesomeIcon icon={faSearch} />
                            </button>
                        </div>
                        {loading ? (
                            <div className="text-center py-4"><i>Cargando datos...</i></div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-hover table-sm table-bordered">
                                    <thead className="table-light">
                                        <tr>
                                            <th>ID</th>
                                            <th>Detalle</th>
                                            <th className="text-center">Acción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.length === 0 ? (
                                            <tr><td colSpan="3" className="text-center py-3">No hay registros</td></tr>
                                        ) : (
                                            items.map(it => {
                                                const itemName = it.nombre || it.razon_social || it.name || it.descripcion || "-";
                                                return (
                                                    <tr key={it.id}>
                                                        <td>{it.id}</td>
                                                        <td>{itemName} {it.apellido ? it.apellido : ''}</td>
                                                        <td className="text-center">
                                                            <button
                                                                className="btn btn-success btn-sm"
                                                                onClick={() => {
                                                                    onSelect({ id: it.id, nombre: `${itemName} ${it.apellido || ''}`.trim() });
                                                                    onClose();
                                                                }}
                                                            >
                                                                Seleccionar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
};

// ─── Componente Principal Reportes2 ──────────────────────────────────────────
const Reportes2 = () => {
    // Datos de API
    const [ordenesOriginales, setOrdenesOriginales] = useState([]);
    const [loading, setLoading] = useState(false);

    const getPrimerDiaMesActual = () => {
        const d = new Date();
        d.setDate(1);
        return d.toISOString().split('T')[0];
    };
    const getUltimoDiaMesActual = () => {
        const d = new Date();
        d.setMonth(d.getMonth() + 1);
        d.setDate(0);
        return d.toISOString().split('T')[0];
    };

    const [fechaDesde, setFechaDesde] = useState(getPrimerDiaMesActual());
    const [fechaHasta, setFechaHasta] = useState(getUltimoDiaMesActual());

    // Estados para modales y filtros EPS
    const [modalEpsOpen, setModalEpsOpen] = useState(false);
    const [filtroEps, setFiltroEps] = useState('');
    const [filtroEpsName, setFiltroEpsName] = useState('');

    // Cargar datos iniciales
    useEffect(() => {
        cargarReporte();
    }, []);

    const cargarReporte = async () => {
        setLoading(true);
        try {
            const response = await authAxios.post('reportes/reportes_2', {
                fecha_inicial: fechaDesde,
                fecha_final: fechaHasta,
                eps: filtroEps
            });
            if (response.data?.Status) {
                setOrdenesOriginales(response.data.datos || []);
            }
        } catch (error) {
            Swal.fire('Error', 'No se pudieron cargar los datos para el reporte', 'error');
            console.error(error);
        }
        setLoading(false);
    };

    const limpiarFiltros = () => {
        setFiltroEps('');
        setFiltroEpsName('');
        setFechaDesde(getPrimerDiaMesActual());
        setFechaHasta(getUltimoDiaMesActual());
        setTimeout(() => cargarReporte(), 100);
    };

    const exportarExcel = () => {
        if (ordenesOriginales.length === 0) {
            Swal.fire('Atención', 'No hay datos para exportar', 'warning');
            return;
        }

        let excelData = [];
        ordenesOriginales.forEach(ord => {
            const nombreCompleto = `${ord.nombre || ''} ${ord.segundo_nombre || ''} ${ord.apellido || ''} ${ord.segundo_apellido || ''}`.trim();
            excelData.push({
                "ID Seguimiento": ord.id,
                "Tipo Documento": ord.tipo_documento || '-',
                "Cédula": ord.cedula || '-',
                "Nombre Completo": nombreCompleto,
                "Fecha Registro": ord.fecha_registro || '-',
                "Usuario": ord.usuario || '-',
                "EPS": ord.eps || '-',
                "Primera Atención": ord.primera_atencion || 'Sin atenciones'
            });
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte_Pacientes");
        XLSX.writeFile(workbook, `Reporte_Pacientes_Ingresados_${new Date().toISOString().split('T')[0]}.xlsx`);
    };

    return (
        <div className="content-wrapper">
            <div className="content">
                <div className="container-fluid pt-4">
                    {/* Tarjeta de Filtros */}
                    <div className="card shadow-sm mb-4" style={{ borderRadius: '10px' }}>
                        <div className="card-header bg-white border-bottom">
                            <h4 className="card-title text-primary m-0" style={{ fontWeight: '600' }}>
                                <FontAwesomeIcon icon={faFilter} className="me-2" />
                                Filtros - Pacientes Ingresados
                            </h4>
                        </div>
                        <div className="card-body bg-light">
                            <div className="row g-3 align-items-end">
                                <div className="col-md-3">
                                    <label className="form-label text-muted small fw-bold">Fecha Desde</label>
                                    <input type="date" className="form-control form-control-sm" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted small fw-bold">Fecha Hasta</label>
                                    <input type="date" className="form-control form-control-sm" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)} />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label text-muted small fw-bold">Empresa (EPS)</label>
                                    <div className="input-group input-group-sm">
                                        <input type="text" className="form-control bg-white" value={filtroEpsName} placeholder="- Seleccione EPS -" readOnly />
                                        {filtroEps && (
                                            <button className="btn btn-outline-danger" type="button" onClick={() => { setFiltroEps(''); setFiltroEpsName(''); }}>
                                                <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                        )}
                                        <button className="btn btn-primary" type="button" onClick={() => setModalEpsOpen(true)}>
                                            <FontAwesomeIcon icon={faSearch} /> Buscar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 text-end">
                                    <button className="btn btn-outline-secondary btn-sm me-2" onClick={limpiarFiltros}>
                                        <FontAwesomeIcon icon={faTimes} className="me-1" /> Limpiar Filtros
                                    </button>
                                    <button className="btn btn-primary btn-sm" onClick={cargarReporte} disabled={loading}>
                                        <FontAwesomeIcon icon={faSearch} className="me-1" /> Obtener del Rango
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Tabla de Resultados */}
                    <div className="card shadow-sm" style={{ borderRadius: '10px' }}>
                        <div className="card-header bg-white d-flex justify-content-between align-items-center">
                            <h5 className="card-title m-0 fw-bold">Pacientes Ingresados ({ordenesOriginales.length})</h5>
                            <div>
                                <button className="btn btn-success btn-sm me-2" onClick={exportarExcel} disabled={loading || ordenesOriginales.length === 0}>
                                    <FontAwesomeIcon icon={faDownload} /> Exportar Excel
                                </button>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover table-striped align-middle m-0" style={{ fontSize: '0.9rem' }}>
                                    <thead className="table-light">
                                        <tr>
                                            <th>ID Seg.</th>
                                            <th>Tipo Doc</th>
                                            <th>Cédula</th>
                                            <th>Nombre Completo</th>
                                            <th>Fecha Registro</th>
                                            <th>Usuario</th>
                                            <th>Empresa / EPS</th>
                                            <th>Primera Atención</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ordenesOriginales.length === 0 ? (
                                            <tr>
                                                <td colSpan="8" className="text-center py-5">
                                                    {loading ? <div>Cargando datos...</div> : <div className="text-muted"><FontAwesomeIcon icon={faSearch} size="2x" className="mb-2 d-block mx-auto" /> No se encontraron resultados con los filtros actuales.</div>}
                                                </td>
                                            </tr>
                                        ) : (
                                            ordenesOriginales.map((ord, idx) => (
                                                <tr key={idx}>
                                                    <td className="fw-bold text-center">#{ord.id}</td>
                                                    <td>{ord.tipo_documento || '-'}</td>
                                                    <td>{ord.cedula || '-'}</td>
                                                    <td className="fw-bold text-secondary">
                                                        {`${ord.nombre || ''} ${ord.segundo_nombre || ''} ${ord.apellido || ''} ${ord.segundo_apellido || ''}`.trim()}
                                                    </td>
                                                    <td>{ord.fecha_registro || '-'}</td>
                                                    <td>{ord.usuario || '-'}</td>
                                                    <td className="fw-bold">{ord.eps || '-'}</td>
                                                    <td className="text-primary">{ord.primera_atencion || <span className="text-muted fst-italic">Sin atenciones</span>}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modales */}
            <ModalSelect
                open={modalEpsOpen}
                onClose={() => setModalEpsOpen(false)}
                title="Seleccionar Empresa (EPS)"
                idMenu={179}
                onSelect={(item) => {
                    setFiltroEps(item.id);
                    setFiltroEpsName(item.nombre);
                }}
            />

        </div>
    );
};

export default Reportes2;
